/**
 * Het stadsgrid. Alle maten uit docs/ARCHITECTURE.md staan hier als code, zodat builders en
 * leveldata dezelfde getallen delen in plaats van ze elk apart te herhalen.
 */

/** Basistile van de stad in meters. Gevelmodules, stoepen en kades zijn hier veelvouden van. */
export const TILE = 4;

export const CITY = {
  tile: TILE,
  floorHeight: 3,
  facadeModule: 4,
  streetWidth: 8,
  pavementWidth: 2,
  pavementHeight: 0.15,
  quayDepth: 6,
  quayHeight: 1.2,
  canalWidth: 12,
  /** Waterpeil ligt onder nul; de kade steekt er `quayHeight` bovenuit. */
  waterLevel: -1.2,
} as const;

/** Tile-index → wereldcoördinaat van het midden van die tile. */
export function tileCenter(tileX: number, tileZ: number): [number, number] {
  return [(tileX + 0.5) * TILE, (tileZ + 0.5) * TILE];
}

/** Wereldcoördinaat → tile-index. */
export function worldToTile(x: number, z: number): [number, number] {
  return [Math.floor(x / TILE), Math.floor(z / TILE)];
}

/** Rond af op het dichtstbijzijnde veelvoud van `step` — voor het uitlijnen van geometrie. */
export function snap(value: number, step: number = TILE): number {
  return Math.round(value / step) * step;
}
